// Small, tasteful accreditations/affiliations strip.
// Uses the official IATA and TAFI logos served from /public.

const IATA = "/iata-logo.png";
const TAFI = "/tafi-logo.png";

export default function Accreditations({
  label = "Accreditations & Affiliations",
  variant = "light", // "light" | "dark"
  className = "",
}) {
  const isDark = variant === "dark";
  return (
    <div className={`flex flex-col items-center gap-4 ${className}`} data-testid="accreditations">
      {label && (
        <p
          className={`text-[11px] uppercase tracking-[0.28em] font-semibold ${
            isDark ? "text-white/60" : "text-brand-slate"
          }`}
        >
          {label}
        </p>
      )}
      <div
        className={`inline-flex items-center gap-8 md:gap-12 rounded-2xl px-6 md:px-8 py-3 md:py-4 ${
          isDark ? "bg-white shadow-md" : "bg-white ring-1 ring-brand-blue/8 shadow-sm"
        }`}
      >
        <img src={IATA} alt="IATA Accredited" className="h-10 md:h-12 w-auto object-contain" />
        <div className="h-8 w-px bg-brand-blue/15" />
        <img src={TAFI} alt="TAFI Member" className="h-10 md:h-12 w-auto object-contain" />
      </div>
    </div>
  );
}
